import { withSentryRouting } from '@sentry/react'
import HelpPage from 'pages/Help'
import InvoicesPage from 'pages/Invoices'
import ItemPage from 'pages/Item'
import ItemImagePage from 'pages/ItemImage'
import ItemsPage from 'pages/Items'
import LoginPage from 'pages/Login'
import OrderPage from 'pages/Order'
import OrdersPage from 'pages/Orders'
import SearchPage from 'pages/Search'
import SettingsPage from 'pages/Settings'
import StatusPage from 'pages/Status'
import TermsPage from 'pages/Terms'
import UpdatesPage from 'pages/Updates'
import { memo, useEffect, useRef } from 'react'
import { Route, Switch, useLocation } from 'react-router-dom'
import LoginRefreshAction from 'router/actions/LoginRefresh'
import LogoutAction from 'router/actions/Logout'
import RouteNotFound from 'router/RouteNotFound'
import { getReseller } from 'state/Reseller'
import { SupportChat } from 'utils'
import PrivateRoute from './PrivateRoute'
import RestrictedRoute from './RestrictedRoute'

const InstrumentedRoute = withSentryRouting(Route)

/*
 * Little disclaimer: avoid exporting other stuff from here. At some point I included the list of statuses here and imported at Menu/index.js, then...... i18next.t() calls inside Order/Modals started failing???
 */

export default memo(Routes)

function Routes() {
	//region Intercom pageviews mayhem
	//used to avoid duplicating the initial Intercom page view (which is automatically sent during initial load by them)
	const isInitial = useRef(true)

	//updates the current page to Intercom (and maybe other future chat widgets in case they support it)...
	//however, right now, Intercom's "Recent page views" feature doesn't auto-update, so it might be misleading when trying to help out a user moving in between screens https://forum.intercom.com/s/question/0D52G00005FfB99SAF
	//TODO since this is not to be reaaally relied upon during chat, there's also a bug that I left for the future: since location and title changes aren't exactly "in sync", sometimes
	const supportChat = SupportChat.use()
	const location    = useLocation()
	useEffect(() => {
			if (supportChat && !isInitial.current) {
				supportChat.sendPageView()
			}
			isInitial.current = false
		},
		//boolean supportChat so it just re-runs if it changes from false to an object
		[!!supportChat, location.pathname, isInitial],  // eslint-disable-line react-hooks/exhaustive-deps
	)
	//endregion

	//If you came here to block a page from being accessed depending on privileges, I must inform you it's not possible,
	// because: hooks. Instead, you must use User.useFullPagePrivilege() at the start of the page, and return its
	// result, if any, instead of the actual page.
	return <Switch>
		<InstrumentedRoute path="/login/:token" component={LoginRefreshAction}/>
		<InstrumentedRoute path="/login" component={LoginPage}/>
		<PrivateRoute path="/logout" component={LogoutAction}/>

		<PrivateRoute path="/items" component={ItemsPage}/>
		<RestrictedRoute path="/invoices" component={InvoicesPage} check={state => getReseller(state)?.show_invoices}/>
		<PrivateRoute path="/order/:id" component={OrderPage}/>
		<PrivateRoute path="/search" component={SearchPage}/>
		<PrivateRoute path="/settings" component={SettingsPage}/>
		<PrivateRoute path="/status" component={StatusPage}/>
		<PrivateRoute path="/updates" component={UpdatesPage}/>
		<PrivateRoute path="/help" component={HelpPage}/>
		<PrivateRoute path={`/:status(${OrdersPage.URIS})`} component={OrdersPage}/> {/* this is used in NotFoundRoute */}
		<PrivateRoute path="/item/:id/image" component={ItemImagePage}/>
		<PrivateRoute path="/item/:id" component={ItemPage}/>
		<PrivateRoute path="/terms" component={TermsPage}/>

		<InstrumentedRoute path="*" component={RouteNotFound}/>
	</Switch>
}
